export const SQUAD_LOGO_URL = process.env.REACT_APP_LOGO || "";
export const CONFIG_COUNTRY = process.env.REACT_APP_COUNTRY || "";
export const SYNDICATE_COUNTRY = process.env.REACT_APP_SYNDICATE_COUNTRY || "";
export const IS_API_ON_THE_SAME_HOST = (process.env.REACT_APP_API_URL || "").includes(window.location.host);

export const DEFAULT_MENU = [
	{
		label: "PRIZES",
		link: "/prizes",
		isAuthed: false,
		isExternal: false,
	},
	{
		label: "HELP",
		link: "/help/game-guidelines",
		mobileLink: "/help",
		isAuthed: false,
		isExternal: false,
	},
	{
		label: "FANTASY CHALLENGE",
		link: "https://nfl.com",
		isAuthed: false,
		isExternal: true,
	},
];
